import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./InterestedForm.css";

const InterestedForm = () => {
  const initialValues = { username: "", email: "", password: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [smShow, setSmShow] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true);
  };

  useEffect(() => {
    console.log(formErrors);
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      console.log(formValues);
    }
  }, [formErrors]);
  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.username) {
      errors.username = "name is required!";
    }
    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }

    return errors;
  };

  return (
    <>
      <div className="container form-container">
        <h2>Lets talk</h2>
        <form
          target="_blank"
          action="https://formsubmit.co/marketing@bizconnectevents.com"
          method="POST"
        >
          <div className="input-data">
            <label for="">Name</label>
            <input
              type="text"
              name="firstname"
              placeholder="Name"
              style={{ width: "100%" }}
              required
            />
          </div>

          <div className="input-data">
            <label for="">Email</label>
            <input
              type="text"
              name="email"
              placeholder="Email address"
              style={{ width: "100%" }}
              required
            />
          </div>

          <div className="input-data">
            <label for="">Phone</label>
            <input
              type="text"
              number="phone"
              placeholder="Phone"
              style={{ width: "100%" }}
              required
            />
          </div>

          <div className="input-data">
            <label for="">Organization</label>
            <input
              type="text"
              name="Organisation"
              placeholder="Organisation"
              style={{ width: "100%" }}
              required
            />
          </div>

          <div className="input-data textarea">
            <label for="">Message</label>
            <textarea
              rows="3"
              cols="80"
              name="message"
              placeholder="write your message"
              style={{ width: "100%" }}
              required
            ></textarea>
          </div>
          <br></br>
          <div classNameName="date-picker">
            <h6>book your slot: </h6>
            <input
              classNameName="dropdown-item"
              type="date"
              placeholder="DD/MM/YYYY"
              style={{ width: "100%" }}
            />
          </div>
          <br></br>
          <button type="submit" className="btn btn-lg btn-dark btn-block">
            Submit Form
          </button>
        </form>
        {/* </div> */}
        {/* </div> */}
      </div>
    </>
  );
};

export default InterestedForm;
